var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-card',{staticClass:"exam-tip",scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('div',{staticClass:"circle"},[_c('div',[_c('icon',{attrs:{"name":"lightbulb"}})],1)])]},proxy:true},{key:"title",fn:function(){return [_vm._v("\n    Exam Tip\n  ")]},proxy:true}])},[_vm._v(" "),_vm._v(" "),_c('p',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }